import React, { useEffect, useState } from 'react';

import CommercialDashboard from './components/BillingDashboard.jsx';
import Messenger from './components/Messenger.jsx';
import Channels from './components/Channels.jsx';
import Sessions from './components/Sessions.jsx';
import ConnectionWizard from './components/ConnectionWizard.jsx';
import HistoryBackfill from './components/HistoryBackfill.jsx';
import Bitrix from './components/Bitrix.jsx';
import Health from './components/Health.jsx';
import Users from './components/Users.jsx';
import Login from './components/Login.jsx';

import { getMe, logout } from './api.js';


function NavigationIcon({ name }) {
  const paths = {
    overview: (
      <>
        <rect x="3" y="3" width="7" height="7" rx="2" />
        <rect x="14" y="3" width="7" height="7" rx="2" />
        <rect x="3" y="14" width="7" height="7" rx="2" />
        <rect x="14" y="14" width="7" height="7" rx="2" />
      </>
    ),
    connections: (
      <>
        <path d="M8 12h8" />
        <path d="M12 8v8" />
        <rect x="3" y="4" width="18" height="16" rx="4" />
      </>
    ),
    bitrix: (
      <>
        <path d="M4 7h16" />
        <path d="M7 3v4" />
        <path d="M17 3v4" />
        <rect x="3" y="5" width="18" height="16" rx="3" />
        <path d="M7 11h3" />
        <path d="M14 11h3" />
        <path d="M7 15h3" />
        <path d="M14 15h3" />
      </>
    ),
    messages: (
      <>
        <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
        <path d="M8 9h8" />
        <path d="M8 13h5" />
      </>
    ),
    diagnostics: (
      <>
        <path d="M3 12h4l2-6 4 12 2-6h6" />
        <path d="M4 4h16v16H4z" opacity=".18" />
      </>
    ),
    settings: (
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06-2.83 2.83-.06-.06A1.7 1.7 0 0 0 15 19.4a1.7 1.7 0 0 0-1 .6 1.7 1.7 0 0 0-.4 1.1V21h-4v-.09A1.7 1.7 0 0 0 8.6 19.4a1.7 1.7 0 0 0-1.88.34l-.06.06-2.83-2.83.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-.6-1 1.7 1.7 0 0 0-1.1-.4H3v-4h.09A1.7 1.7 0 0 0 4.6 8.6a1.7 1.7 0 0 0-.34-1.88l-.06-.06 2.83-2.83.06.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-.6 1.7 1.7 0 0 0 .4-1.1V3h4v.09A1.7 1.7 0 0 0 15.4 4.6a1.7 1.7 0 0 0 1.88-.34l.06-.06 2.83 2.83-.06.06A1.7 1.7 0 0 0 19.4 9c.39.27.75.63 1 1 .26.34.4.75.4 1.1V13h-.09A1.7 1.7 0 0 0 19.4 15z" />
      </>
    ),
    menu: (
      <>
        <path d="M4 7h16" />
        <path d="M4 12h16" />
        <path d="M4 17h16" />
      </>
    ),
    logout: (
      <>
        <path d="M10 17l5-5-5-5" />
        <path d="M15 12H3" />
        <path d="M14 3h5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5" />
      </>
    ),
  };

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths[name] || paths.overview}
    </svg>
  );
}


function WorkspaceTabs({
  ariaLabel,
  tabs,
  initialTab,
}) {
  const firstEnabled = tabs.find((tab) => !tab.disabled);
  const [activeTab, setActiveTab] = useState(
    initialTab || firstEnabled?.key,
  );

  useEffect(() => {
    const switchWorkspaceTab = (event) => {
      const requested = String(
        event?.detail || ''
      );

      const target = tabs.find(
        (tab) => (
          tab.key === requested
          && !tab.disabled
        )
      );

      if (target) {
        setActiveTab(target.key);
      }
    };

    window.addEventListener(
      'svyazka:workspace-tab',
      switchWorkspaceTab,
    );

    return () => {
      window.removeEventListener(
        'svyazka:workspace-tab',
        switchWorkspaceTab,
      );
    };
  }, [tabs]);

  const selected = (
    tabs.find(
      (tab) => tab.key === activeTab && !tab.disabled,
    )
    || firstEnabled
  );

  const Component = selected?.component;

  return (
    <section className="mf-workspace">
      <div
        className="mf-section-tabs"
        role="tablist"
        aria-label={ariaLabel}
      >
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={selected?.key === tab.key}
            className={
              selected?.key === tab.key
                ? 'mf-section-tab active'
                : 'mf-section-tab'
            }
            disabled={tab.disabled}
            title={tab.disabledReason || undefined}
            onClick={() => {
              if (!tab.disabled) {
                setActiveTab(tab.key);
              }
            }}
          >
            <span>{tab.label}</span>

            {tab.disabled && (
              <span className="mf-tab-lock">
                Позже
              </span>
            )}
          </button>
        ))}
      </div>

      <div className="mf-workspace-body">
        {Component ? <Component /> : null}
      </div>
    </section>
  );
}


function ConnectionsWorkspace() {
  return (
    <section className="mf-connections-page">
      <header className="mf-page-hero">
        <div>
          <div className="mf-page-eyebrow">
            КАНАЛЫ
          </div>

          <h1>Каналы</h1>

          <p>
            Подключайте рабочие аккаунты и ботов.
            Каждый канал работает через свою Открытую линию Битрикс24.
          </p>
        </div>

        <div className="mf-page-hero-badge">
          Telegram · MAX · WhatsApp
        </div>
      </header>

      <ConnectionWizard />

      <WorkspaceTabs
        ariaLabel="Тип подключения"
        initialTab="personal"
        tabs={[
          {
            key: 'personal',
            label: 'Личные аккаунты',
            component: Sessions,
          },
          {
            key: 'bots',
            label: 'Боты и интеграции',
            component: Channels,
          },
        ]}
      />
    </section>
  );
}


function BitrixWorkspace() {
  return (
    <section className="mf-product-page mf-bitrix-page">
      <header className="mf-page-hero">
        <div>
          <div className="mf-page-eyebrow">
            CRM
          </div>

          <h1>Bitrix24 и открытые линии</h1>

          <p>
            Состояние интеграции, регистрация коннектора
            и подключение открытых линий.
          </p>
        </div>

        <div className="mf-page-hero-badge">
          Связка × Битрикс24
        </div>
      </header>

      <Bitrix />
    </section>
  );
}


function HealthWorkspace() {
  return (
    <section className="mf-product-page mf-health-page">
      <header className="mf-page-hero">
        <div>
          <div className="mf-page-eyebrow">
            СИСТЕМА
          </div>

          <h1>Диагностика</h1>

          <p>
            Текущее состояние сервисов,
            инфраструктуры и соединений шлюза мессенджеров.
          </p>
        </div>

        <div className="mf-page-hero-badge mf-page-hero-badge-success">
          Мониторинг
        </div>
      </header>

      <Health />
    </section>
  );
}


function SettingsWorkspace() {
  return (
    <section className="mf-product-page mf-settings-page">
      <header className="mf-page-hero">
        <div>
          <div className="mf-page-eyebrow">
            УПРАВЛЕНИЕ
          </div>

          <h1>Настройки</h1>

          <p>
            Команда, роли и параметры рабочего
            пространства мессенджеров.
          </p>
        </div>
      </header>

      <WorkspaceTabs
        ariaLabel="Раздел настроек"
        initialTab="team"
        tabs={[
          {
            key: 'general',
            label: 'Основные',
            disabled: true,
            disabledReason: (
              'Основные настройки будут подключены '
              + 'на отдельном этапе.'
            ),
          },
          {
            key: 'security',
            label: 'Безопасность',
            disabled: true,
            disabledReason: (
              'Настройки безопасности будут подключены '
              + 'на отдельном этапе.'
            ),
          },
          {
            key: 'storage',
            label: 'Хранение данных',
            disabled: true,
            disabledReason: (
              'Настройки хранения будут подключены '
              + 'на отдельном этапе.'
            ),
          },
          {
            key: 'notifications',
            label: 'Уведомления',
            disabled: true,
            disabledReason: (
              'Уведомления будут подключены '
              + 'на отдельном этапе.'
            ),
          },
          {
            key: 'team',
            label: 'Команда и доступ',
            component: Users,
          },
        ]}
      />
    </section>
  );
}


const PAGES = {
  overview: {
    label: 'Обзор',
    icon: 'overview',
    component: CommercialDashboard,
    roles: ['admin'],
  },
  connections: {
    label: 'Каналы',
    icon: 'connections',
    component: ConnectionsWorkspace,
    roles: ['admin'],
  },
  bitrix: {
    label: 'Открытые линии',
    icon: 'bitrix',
    component: BitrixWorkspace,
    roles: ['admin'],
  },
  messages: {
    label: 'Сообщения',
    icon: 'messages',
    component: Messenger,
    roles: ['admin'],
  },
  history: {
    label: 'История',
    icon: 'messages',
    component: HistoryBackfill,
    roles: ['admin'],
  },
  diagnostics: {
    label: 'Диагностика',
    icon: 'diagnostics',
    component: HealthWorkspace,
    roles: ['admin'],
  },
  settings: {
    label: 'Настройки',
    icon: 'settings',
    component: SettingsWorkspace,
    roles: ['admin'],
  },
};


const NAVIGATION_GROUPS = [
  {
    label: 'Связка',
    pages: [
      'overview',
      'connections',
      'bitrix',
    ],
  },
];


function userInitials(user) {
  const value = (
    user?.display_name
    || user?.email
    || 'MF'
  ).trim();

  const parts = value
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);

  const initials = parts
    .map((part) => part[0])
    .join('')
    .toUpperCase();

  return initials || 'MF';
}


export default function App() {
  const [user, setUser] = useState(undefined);
  const [page, setPage] = useState('overview');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const onSvyazkaNavigate = (event) => {
      const nextPage = String(
        event?.detail || ''
      );

      if (!PAGES[nextPage]) {
        return;
      }

      setPage(nextPage);
      setSidebarOpen(false);
    };

    window.addEventListener(
      'svyazka:navigate',
      onSvyazkaNavigate,
    );

    return () => {
      window.removeEventListener(
        'svyazka:navigate',
        onSvyazkaNavigate,
      );
    };
  }, []);


  useEffect(() => {
    getMe().then((resolvedUser) => {
      setUser(resolvedUser || null);
    });

    const onLogout = () => setUser(null);

    window.addEventListener(
      'auth:logout',
      onLogout,
    );

    return () => {
      window.removeEventListener(
        'auth:logout',
        onLogout,
      );
    };
  }, []);

  useEffect(() => {
    if (!sidebarOpen) {
      return undefined;
    }

    const closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        setSidebarOpen(false);
      }
    };

    window.addEventListener(
      'keydown',
      closeOnEscape,
    );

    return () => {
      window.removeEventListener(
        'keydown',
        closeOnEscape,
      );
    };
  }, [sidebarOpen]);

  if (user === undefined) {
    return (
      <div className="mf-auth-loading">
        <div className="mf-auth-loading-mark">
          MF
        </div>

        <div>
          <strong>Связка</strong>
          <span>Загрузка рабочего пространства…</span>
        </div>
      </div>
    );
  }

  if (user === null) {
    return (
      <Login
        onSuccess={(resolvedUser) => {
          setUser(resolvedUser);
        }}
      />
    );
  }

  const visiblePages = Object.entries(PAGES)
    .filter(([, configuration]) => (
      configuration.roles.includes(user.role)
    ));

  const safePage = visiblePages.some(
    ([key]) => key === page,
  )
    ? page
    : visiblePages[0][0];

  const pageConfiguration = PAGES[safePage];
  const Page = pageConfiguration.component;

  const displayName = (
    user.display_name
    || user.email
  );

  const roleLabel = (
    user.role === 'admin'
      ? 'Администратор'
      : 'Оператор'
  );

  const selectPage = (nextPage) => {
    setPage(nextPage);
    setSidebarOpen(false);
  };

  const doLogout = async () => {
    await logout();
    setUser(null);
  };

  const visiblePageKeys = new Set(
    visiblePages.map(([key]) => key),
  );

  return (
    <div
      className={
        sidebarOpen
          ? 'mf-app-shell sidebar-open'
          : 'mf-app-shell'
      }
    >
      <button
        type="button"
        className="mf-sidebar-backdrop"
        aria-label="Закрыть меню"
        onClick={() => setSidebarOpen(false)}
      />

      <aside
        className="mf-sidebar"
        aria-label="Основная навигация"
      >
        <div className="mf-brand">
          <div className="mf-brand-mark">
            MF
          </div>

          <div className="mf-brand-copy">
            <strong>Связка</strong>
            <span>Мессенджеры в Битрикс24</span>
          </div>
        </div>

        <nav className="mf-navigation">
          {NAVIGATION_GROUPS.map((group) => {
            const groupPages = group.pages.filter(
              (key) => visiblePageKeys.has(key),
            );

            if (groupPages.length === 0) {
              return null;
            }

            return (
              <div
                className="mf-navigation-group"
                key={group.label}
              >
                <div className="mf-nav-label">
                  {group.label}
                </div>

                <div className="mf-nav-list">
                  {groupPages.map((key) => {
                    const configuration = PAGES[key];

                    return (
                      <button
                        type="button"
                        key={key}
                        className={
                          safePage === key
                            ? 'mf-nav-button active'
                            : 'mf-nav-button'
                        }
                        aria-current={
                          safePage === key
                            ? 'page'
                            : undefined
                        }
                        onClick={() => selectPage(key)}
                      >
                        <NavigationIcon
                          name={configuration.icon}
                        />

                        <span>
                          {configuration.label}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </nav>

        <div className="mf-sidebar-bottom">
          <div className="mf-account">
            <div className="mf-account-avatar">
              {userInitials(user)}
            </div>

            <div className="mf-account-copy">
              <strong>{displayName}</strong>
              <span>{roleLabel}</span>
            </div>
          </div>

          <button
            type="button"
            className="mf-signout"
            onClick={doLogout}
          >
            <NavigationIcon name="logout" />
            <span>Выйти</span>
          </button>
        </div>
      </aside>

      <main
        className={
          safePage === 'messages'
            ? 'mf-main mf-main--messages'
            : 'mf-main'
        }
      >
        <div className="mf-mobile-topbar">
          <button
            type="button"
            className="mf-mobile-menu"
            aria-label="Открыть меню"
            onClick={() => setSidebarOpen(true)}
          >
            <NavigationIcon name="menu" />
          </button>

          <div className="mf-mobile-title">
            {pageConfiguration.label}
          </div>

          <div className="mf-mobile-brand">
            MF
          </div>
        </div>

        <div className="mf-page-body">
          <Page currentUser={user} />
        </div>
      </main>
    </div>
  );
}
